// Reading what helpers/api rejects with. Kept out of helpers/api so specs that mock it keep these working.

export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

const GENERIC = Symbol('generic request error');

// What helpers/api rejects with when the server sent no `errors`: [GENERIC_ERROR_MESSAGE], with the axios error
// reachable as `cause` and through `response`, `message` and the rest, where callers used to get the axios error.
// `name` and `stack` too, so a caller that hands it to airbrake.notify keeps the error's type and backtrace.
export function genericRequestError(error) {
  const generic = [GENERIC_ERROR_MESSAGE];
  Object.defineProperty(generic, GENERIC, { value: true });
  Object.defineProperty(generic, 'cause', { value: error });
  ['response', 'request', 'config', 'code', 'message', 'name', 'stack', 'isAxiosError'].forEach((field) => {
    Object.defineProperty(generic, field, { get: () => error?.[field] });
  });

  return generic;
}

// The server's errors list from a rejected request, or [] when it sent none (a 5xx, a network failure, field errors).
// Usually messages; pass a type for endpoints whose list holds objects.
export function serverErrors<T = string>(error: unknown): T[] {
  return Array.isArray(error) && !error[GENERIC] ? error : [];
}

// The server's messages from a rejected request, or [fallback] when it sent none.
export function requestErrors(error: unknown, fallback = GENERIC_ERROR_MESSAGE): string[] {
  const messages = serverErrors(error);
  return messages.length > 0 ? messages : [fallback];
}
